import { ProductCategory } from '../types';

export const MOCK_PRODUCT_CATEGORIES: readonly ProductCategory[] = [
  {
    id: '1',
    name: 'Хлебобулочные изделия',
    created_at: new Date('2024-01-01').toISOString(),
    is_deleted: false
  },
  {
    id: '2',
    name: 'Молочные продукты',
    created_at: new Date('2024-01-01').toISOString(),
    is_deleted: false
  },
  {
    id: '3',
    name: 'Мясные изделия',
    created_at: new Date('2024-01-01').toISOString(),
    is_deleted: false
  },
  {
    id: '4',
    name: 'Овощи и фрукты',
    created_at: new Date('2024-01-01').toISOString(),
    is_deleted: false
  }
] as const;
